module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9ABwO"))).then(() => parcelRequire('hEqeo'));